import { AfterViewInit, Component, effect, inject, OnInit } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { ConfigService } from '../services/config.service';
import { RouterLink } from '@angular/router';
import { SocialLinksComponent } from './social-links/social-links.component';
import { LayoutService } from '../services/layout.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../services/theme.service';
import { FeaturedContent } from '../models/core/featured-content.model';
import { FeaturedContentService } from '../services/featured-content.service';
import { FeaturedContentName } from '../models/core/featured-content-name.enum';
import { IframeCommunicationService } from '../services/iframe-communication.service';

@Component({
  selector: 'cwo-footer',
  standalone: true,
  imports: [TranslocoPipe, RouterLink, SocialLinksComponent, CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit, AfterViewInit{
  configState = inject(ConfigService).configState;
  translocoService = inject(TranslocoService);
  layoutService = inject(LayoutService);
  themeService = inject(ThemeService);
  private iframeCommunicationService = inject(IframeCommunicationService);

  private featuredContentService = inject(FeaturedContentService);
  footerFeaturedContentLinks: FeaturedContent[] = [];

  routerLinks: {
    name: Observable<any>;
    routerLink?: string;
    type?: string;
    href?: string;
  }[] = [];

  constructor() {
    this.buildRouterLinks();

    effect(() => {
      if (this.iframeCommunicationService.isInIframe()) {
        this.themeService.theme();
        this.buildRouterLinks();
      }
    });
  }

  private buildRouterLinks(): void {
    this.routerLinks = [];
    if (this.configState().store?.showFoodFeedback) {
      this.routerLinks.push({
        name: this.translocoService.selectTranslate('footer.food_feedback'),
        routerLink: 'questionnaire',
        type: 'Feedback',
      });
    }
    if (this.configState().store?.showWebsiteFeedback) {
      this.routerLinks.push({
        name: this.translocoService.selectTranslate('footer.feedback'),
        routerLink: 'questionnaire',
        type: 'Experience',
      });
    }
    if (!this.themeService.theme()?.hideCareerQuestionnaireLink) {
      if (this.configState().store?.careersQuestionnaireLink) {
        this.routerLinks.push({
          name: this.translocoService.selectTranslate('footer.careers'),
          href: this.configState().store?.careersQuestionnaireLink,
        });
      } else {
        this.routerLinks.push({
          name: this.translocoService.selectTranslate('footer.careers'),
          routerLink: 'questionnaire',
          type: 'Career',
        });
      }
    }
    if (!this.themeService.theme()?.hideContactQuestionnaireLink) {
      if (this.configState().store?.contactQuestionnaireLink) {
        this.routerLinks.push({
          name: this.translocoService.selectTranslate('footer.contact'),
          href: this.configState().store?.contactQuestionnaireLink,
        });
      } else {
        this.routerLinks.push({
          name: this.translocoService.selectTranslate('footer.contact'),
          routerLink: 'questionnaire',
          type: 'Contact',
        });
      }
    }
    if (
      this.configState().store?.showEGiftButton &&
      this.configState().store?.eGiftPageLink
    ) {
      this.routerLinks.push({
        name: this.translocoService.selectTranslate('footer.gcs'),
        href: this.configState().store?.eGiftPageLink,
      });
    }
  }

  ngOnInit(): void {
    this.footerFeaturedContentLinks = this.featuredContentService.getFeaturedContentsByAreaName(FeaturedContentName.FOOTER_LINKS);
  }

  ngAfterViewInit(): void {
    this.layoutService.calculateFooterHeight();    
  }
}
